import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import ReadySheetFormRouteMiddleware from "./middleware/auth/readysheetformValidRoute";

// ✅ Lazy import
const ReadySheetFormformList = lazy(() => import("app/pages/Inventory/ReadySheetForm/List"));

export const readySheetFormRoute = [
  {
    middleware: [
      {
        element: ReadySheetFormRouteMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/inventory/readysheetform",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ReadySheetFormformList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      // {
      //   path: "/dashboard/inventory/readysheetform/add",
      //   element: (
      //     <Suspense fallback={<div>Loading...</div>}>
      //       <Page component={AddReadySheetForm} layout={"vertical-default"} />
      //     </Suspense>
      //   ),
      // },
    ],
  },
];
